// Deterministic avatar colour for a person, derived from their id so the same
// person always gets the same colour across the board and their profile page.
// This is presentation (not mock data), so it lives in shared rather than in a
// feature's mock module.

const AVATAR_COLORS = [
  '#FF8C4B',
  '#5DD5E9',
  '#9A6BD7',
  '#81BD2E',
  '#F89E18',
  '#2563EB',
  '#E0529C',
];

function hashId(value: string): number {
  let hash = 0;
  for (let i = 0; i < (value ?? '').length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash;
}

export function avatarColorFor(id: string): string {
  return AVATAR_COLORS[hashId(id) % AVATAR_COLORS.length];
}
